import { PerformanceEventName, PerformanceEventProperties } from '@ms/yammer-telemetry/dist/performance';

import { getFirstMeaningfulPaintContext, setFirstMeaningfulPaintContext } from '../telemetryStore';

import { endAndReportPerformanceMeasure, getPerformanceMeasureEntry } from './performance';

type FirstMeaningfulPaintCallback = (firstMeaningfulPaintDuration: number) => void;
let firstMeaningfulPaintCallback: FirstMeaningfulPaintCallback;

type SetFirstMeaningfulPaintCallback = (callback: FirstMeaningfulPaintCallback) => void;
export const setFirstMeaningfulPaintCallback: SetFirstMeaningfulPaintCallback = (callback) => {
  firstMeaningfulPaintCallback = callback;
};

export interface ReportFirstMeaningfulPaintOptions {
  readonly eventProperties: PerformanceEventProperties;
}

type ReportFirstMeaningfulPaint = (options: ReportFirstMeaningfulPaintOptions) => void;
export const reportFirstMeaningfulPaint: ReportFirstMeaningfulPaint = ({ eventProperties }) => {
  const fmpContext = getFirstMeaningfulPaintContext();
  const { authPageLoadDuration, firstMeaningfulPaintReported } = fmpContext;

  if (firstMeaningfulPaintReported) {
    return;
  }

  const eventName = PerformanceEventName.FirstMeaningfulPaint;

  endAndReportPerformanceMeasure({
    eventName,
    measureKey: eventName,
    fromNavigationStart: true,
    durationOffset: authPageLoadDuration,
    eventProperties,
  });

  setFirstMeaningfulPaintContext({ ...fmpContext, firstMeaningfulPaintReported: true });

  if (firstMeaningfulPaintCallback) {
    const { duration } = getPerformanceMeasureEntry(eventName);
    firstMeaningfulPaintCallback(duration);
  }
};

export interface ReportAuthPageLoadOptions {
  readonly eventProperties: PerformanceEventProperties;
}

type ReportAuthPageLoad = (options: ReportAuthPageLoadOptions) => void;
export const reportAuthPageLoad: ReportAuthPageLoad = ({ eventProperties }) => {
  const eventName = PerformanceEventName.AuthPageLoad;

  endAndReportPerformanceMeasure({
    eventName,
    measureKey: eventName,
    fromNavigationStart: true,
    eventProperties,
  });

  const fmpContext = getFirstMeaningfulPaintContext();
  const { duration } = getPerformanceMeasureEntry(eventName);

  setFirstMeaningfulPaintContext({ ...fmpContext, authPageLoadDuration: duration });
};
